import React from 'react';
import { Link } from 'react-router-dom';

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-600 to-blue-600 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl p-8 max-w-2xl w-full text-center">
        <div className="text-6xl mb-4">🔍</div>
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Page Not Found</h1>
        <p className="text-gray-600 mb-8">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="bg-blue-50 border-l-4 border-blue-500 p-4 mb-8 text-left">
          <p className="text-sm text-blue-800 mb-3">
            <strong>Looking for demo reports?</strong> Try these links:
          </p>
          <ul className="space-y-2 text-sm text-blue-700">
            <li>
              <Link to="/demo" className="hover:underline font-medium">
                → Demo Dashboard (3 sample reports)
              </Link>
            </li>
            <li>
              <Link to="/demo-report/demo-1" className="hover:underline font-medium">
                → Acme Restaurant Report
              </Link>
            </li>
            <li>
              <Link to="/demo-report/demo-2" className="hover:underline font-medium">
                → TechStart Industries Report
              </Link>
            </li>
            <li>
              <Link to="/demo-wizard" className="hover:underline font-medium">
                → Demo Wizard Walkthrough
              </Link>
            </li>
          </ul>
        </div>

        <div className="space-y-3">
          <Link
            to="/home"
            className="block w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 px-6 rounded-lg shadow-lg transition-colors"
          >
            Go to Home Page
          </Link>
          <div className="flex gap-3">
            <Link
              to="/demo"
              className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-2 px-4 rounded-lg transition-colors"
            >
              View Demo
            </Link>
            <Link
              to="/sign-in"
              className="flex-1 bg-gray-200 hover:bg-gray-300 text-gray-700 font-semibold py-2 px-4 rounded-lg transition-colors"
            >
              Sign In
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
